export class Subscription {
    id: string;
    description: string;
}
